import { render, staticRenderFns } from "./nav_iconA.vue?vue&type=template&id=40721dba&scoped=true"
import script from "./nav_iconA.vue?vue&type=script&lang=js"
export * from "./nav_iconA.vue?vue&type=script&lang=js"
import style0 from "./nav_iconA.vue?vue&type=style&index=0&id=40721dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40721dba",
  null
  
)

export default component.exports